import {
	Box,
	Flex,
	Heading,
	Select,
	SimpleGrid,
	useColorModeValue,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Brand from 'components/card/Brand';
import { LoadingSpinner } from 'components/loading/LoadingSpinner';
import ResultMessage from 'components/modal/ResultMessage';
import { NAVIGATE } from 'constant/navigation';
import { getImage } from 'utils/format';
import { handleCloseModal } from 'utils/hooks';
import { SearchBar } from 'views/client/brands/components/Search';

export default function BrandDashboard() {
	const BRANDS = useSelector((state) => state.store.storeAllBrand);
	const [search, setSearch] = useState('');
	const [selectedCategory, setSelectedCategory] = useState('all');
	const [loading, setLoading] = useState(false);
	const [message, setMessage] = useState({
		state: false,
		title: '',
		subtitle: '',
	});

	const filteredBrands = BRANDS.filter(
		(brand) =>
			brand.brandName.toLowerCase().includes(search.toLowerCase()) &&
			(selectedCategory === 'all' ||
				brand?._categoryId?.name === selectedCategory)
	);

	const categories = [
		...new Set(BRANDS.map((brand) => brand?._categoryId?.name)),
	];

	const textColor = useColorModeValue('gray.900', 'gray.100');
	const navigate = useNavigate();

	return (
		<Box pt={{ base: '80px', md: '80px', xl: '80px' }}>
			<Heading
				mb='20px'
				color={textColor}
				fontSize='2xl'
				ms='24px'
				fontWeight='700'
			>
				Tus marcas favoritas
			</Heading>

			<Flex pl='1rem' w='90%' mb='36px'>
				<SearchBar setSearch={setSearch} />
				<Select
					fontSize='sm'
					id='edit_product'
					variant='main'
					h='44px'
					maxh='44px'
					me={{ base: '10px', md: '20px' }}
					value={selectedCategory}
					onChange={(e) => setSelectedCategory(e.target.value)}
					color={textColor}
				>
					<option color={textColor} value='all'>
						Todas las categorías
					</option>
					{categories.map((category, index) => (
						<option color={textColor} key={index} value={category}>
							{category}
						</option>
					))}
				</Select>
			</Flex>
			<LoadingSpinner loading={loading} />
			<SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} gap='20px'>
				{!loading &&
					filteredBrands.map((brand) => {
						const image = getImage(brand.image);

						return (
							<Brand
								key={brand.id}
								brand={brand}
								image={image}
								navigate={() =>
									navigate(NAVIGATE.BRANDS_DETAIL, {
										state: {
											brand: brand,
											brandImg: image,
											brandData: BRANDS,
										},
									})
								}
							/>
						);
					})}
			</SimpleGrid>

			<ResultMessage
				isOpen={message.state}
				onClose={() => handleCloseModal(setMessage)}
				message={message}
			/>
		</Box>
	);
}
